module.exports = __webpack_public_path__ + "static/media/20200731-151027-003.9b31c027.png";